import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Monsieur Bassin. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
